export default __webpack_public_path__ + "static/header-iconic-link-solutions-icon8.url-9a1408e3d66d012ee1ad8aeb0419c999.svg";